import { useLayoutEffect } from 'react';

export function useVisualViewportHeight() {
  useLayoutEffect(() => {
    const root = document.documentElement;

    // initialize
    const setVvh = () => {
      const vv = window.visualViewport;
      // Use visual viewport height when available, otherwise fall back to 100dvh/innerHeight
      const px = Math.round((vv?.height ?? window.innerHeight));
      root.style.setProperty('--vvh', `${px}px`);
    };

    setVvh();

    // Listen to visual viewport changes (keyboard open/close, URL bar collapse, rotation)
    window.visualViewport?.addEventListener('resize', setVvh);
    window.visualViewport?.addEventListener('scroll', setVvh);
    // Fallback listeners
    window.addEventListener('resize', setVvh);
    window.addEventListener('orientationchange', setVvh);

    return () => {
      window.visualViewport?.removeEventListener('resize', setVvh);
      window.visualViewport?.removeEventListener('scroll', setVvh);
      window.removeEventListener('resize', setVvh);
      window.removeEventListener('orientationchange', setVvh);
    };
  }, []);
}
